export { default as MicrosoftIcon } from "./MicrosoftIcon";
